export class CommonAddressRequestFilter {
    public addressName?: string;
    public addressStreet?: string;
    public addressStreetNumber?: string;
    public addressPostalCode?: string;
    public addressCity?: string;
    public addressCountryIso2?: string;
    public addressLookupIn?: string[];

    constructor(json: any) {
        this.addressName = json.addressName || undefined;
        this.addressStreet = json.addressStreet || undefined;
        this.addressStreetNumber = json.addressStreetNumber || undefined;
        this.addressPostalCode = json.addressPostalCode || undefined;
        this.addressCity = json.addressCity || undefined;
        this.addressCountryIso2 = json.addressCountryIso2 || undefined;
        this.addressLookupIn =
            json.addressLookupIn && json.addressLookupIn.length > 0 ? json.addressLookupIn : undefined;
    }
}
